export class InvalidSpotColorError extends Error {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "message", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: "Invalid spot color"
    });
  }
}